import { Heading, Text, UnorderedList, ListItem } from '@chakra-ui/react';

const PrivacyPolicyContent = () => (
  <>
    <Heading size="md">Protection des données à caractère personnel</Heading>

    <Text>
      Article 1 a désigné un Délégué à la Protection des données personnelles
      qui peut être contacté à alexandre.nguyen-van-ho@article-1.eu.
    </Text>

    <Heading size="sm">Données récoltées</Heading>

    <Text>
      Lors de l’inscription sur INSPIRE, l’association Article 1 est amenée à
      recueillir les données à caractère personnel suivantes :
    </Text>
    <UnorderedList>
      <ListItem>
        pour les Lycéens : prénom, nom, code postal, adresse email, numéro de
        téléphone, lycée, genre, section du baccalauréat, notes scolaires, goûts
        dans les matières et domaines, activités extrascolaires, environnement
        d’études, lycée et département d’étude, principales interrogations
        post-bac, bourse d’étude.
      </ListItem>
      <ListItem>
        pour les Eclaireurs : prénom, nom, adresse email, numéro de téléphone,
        code postal, date de naissance, genre, bourse d’étude, section du
        baccalauréat, lycée du baccalauréat, moyenne au bac, parcours d’étude,
        déclarations sur des expériences relatives à un choix d’orientation et
        établissements d’étude fréquentés, déclarations sur des expériences
        relatives à la vie étudiante.
      </ListItem>
      <ListItem>
        Pour les Équipes Pédagogiques : prénom, nom, adresse email
        professionnelle, lycée, fonction.
      </ListItem>
    </UnorderedList>
    <Text>
      Le caractère obligatoire ou facultatif des données personnelles demandées
      et les éventuelles conséquences d’un défaut de réponse sont précisés lors
      de leur collecte.
    </Text>
    <Text>
      Les informations et coordonnées personnelles collectées dans le cadre de
      la création d’un profil INSPIRE permettront à l’association Article 1, le
      cas échéant, de :
    </Text>
    <UnorderedList>
      <ListItem>
        proposer aux Lycéens de contacter des Éclaireurs qui correspondent à
        leur profil et pourront répondre au mieux à leurs questions (même ville,
        mêmes études envisagées, même bac, même niveau au lycée, boursier…) ;
      </ListItem>
      <ListItem>
        mieux comprendre les freins des Lycéens concernant leur choix
        d’orientation afin de mieux cibler les actions du programme INSPIRE à
        l’avenir ;
      </ListItem>
      <ListItem>évaluer l’impact du programme </ListItem>
      <ListItem>
        proposer aux Lycéens et Eclaireurs de témoigner sur leur parcours et
        expériences ;
      </ListItem>
      <ListItem>
        proposer l’accès aux autres programmes proposés par l’association
        Article 1 ;
      </ListItem>
      <ListItem>
        proposer aux Équipes pédagogiques de contribuer au développement
        d’INSPIRE (tests utilisateurs, identification des besoins…).
      </ListItem>
    </UnorderedList>

    <Text>Aucun utilisateur ne sera nommé individuellement lors :</Text>
    <UnorderedList>
      <ListItem>
        des analyses de données internes à l’association Article 1,
      </ListItem>
      <ListItem>
        des communications sur l’impact du programme auprès des financeurs de
        l’association Article 1,
      </ListItem>
      <ListItem>d’éventuelles publications d’articles de recherche.</ListItem>
    </UnorderedList>

    <Text>
      Les données collectées seront réservées à l’usage exclusif de
      l’association Article 1 pour les seuls besoins de fonctionnement
      d’INSPIRE. Afin de permettre à l’équipe de faire des comparaisons
      pluriannuelles de l’impact du programme, les données seront stockées par
      l’association Article 1 pendant 10 ans sur des serveurs hébergés en
      Europe. Au-delà de cette date, elles seront effacées.
    </Text>

    <Text>
      Concernant les Lycéens ayant demandé à s’inscrire à la lettre
      d’information de notre partenaire Annabac : leurs prénom, nom, filière,
      classe et adresse e-mail seront transmis de manière sécurisée à Annabac à
      cette fin. Le traitement de ces données par Annabac sera régi par leurs
      propres conditions générales d’utilisation que nous invitons les
      utilisateurs à consulter avant toute souscription.
    </Text>

    <Text>
      Concernant les Lycéens s’étant inscrit dans le cadre du Parcours
      Pédagogique, ou ayant accepté via leur compte de partager leur profil à
      leur établissement scolaire : l’Equipe pédagogique de leur lycée pourra,
      sous réserve du respect des modalités d’accès définies à l’article 3
      ci-dessus et afin de les accompagner au mieux dans leurs choix
      d’orientation, accéder à leur profil.
    </Text>

    <Text>
      Chaque utilisateur est informé que pour les besoins de l’exploitation
      d’INSPIRE ou pour répondre à des obligations légales ou réglementaires,
      les données sont communiquées à un sous-traitant situé en dehors de
      l’Union Européenne et notamment aux Etats-Unis. Toutefois, ce transfert
      est encadré par l’accord entre l’Union européenne et les Etats Unis, le
      Privacy Shield, qui offre une protection essentiellement équivalente aux
      exigences européennes au regard de la protection des données à caractère
      personnel.
    </Text>

    <Text>
      Conformément à la loi n°78-17 du 6 janvier 1978 relative à l’informatique,
      aux fichiers et aux libertés telle que modifiée (« loi Informatique et
      Libertés »), ainsi qu’au nouveau règlement européen 2016/679 du Parlement
      européen et du Conseil qui sera applicable à compter du 25 mai 2018, et
      toute loi et règlement qui pourrait les succéder, l’ensemble des données
      collectées peut donner lieu à l’exercice du droit d’accès, de
      rectification et d’opposition pour motifs légitimes, ou donner lieu à des
      instructions sur le sort des données suite à un décès les conditions et
      limites prévues par les articles 38, 39 et 40 de la loi Informatique et
      Libertés.
    </Text>

    <Text>
      A cet effet, chaque utilisateur peut obtenir une copie des données à
      caractère personnel le concernant et procéder à leur rectification en
      adressant un email à l’adresse suivante : contact@inspire-orientation.org
    </Text>

    <Text>
      Les traitements de données réalisés ont fait l’objet d’une déclaration
      auprès de la Commission Nationale de l’Informatique et des Libertés
      (CNIL).
    </Text>

    <Heading size="sm">Cookies</Heading>

    <Text>
      Un cookie est un petit fichier texte sauvegardé sur l’ordinateur de
      l’utilisateur ou son appareil mobile puis récupéré lors de ses visites
      ultérieures. Article 1 utilise des cookies pour que la visite de
      l’utilisateur soit plus simple et agréable. Article 1 n’utilise pas les
      cookies pour conserver des informations personnelles ni pour divulguer des
      informations à des tiers.
    </Text>

    <Text>
      Article utilise des cookies nécessaires au fonctionnement du service et
      permettant la navigation de l’utilisateur sur le site Internet ainsi que
      des cookies de mesure d’audience et analytiques afin d’identifier d’où
      viennent les utilisateurs et établir des statistiques de fréquentations
      anonymes.
    </Text>

    <Text>
      Certaines fonctionnalités de ce site Internet s’appuient sur des services
      proposés par des sites tiers. Ces fonctionnalités déposent des cookies
      permettant notamment à ces sites de tracer votre navigation, et à Article
      1 d’améliorer l’expérience des utilisateurs et les services proposés en
      continu.
    </Text>

    <Text>
      Notre site Internet utilise des cookies Crisp, l’outil de messagerie
      instantané que nous utilisons pour venir en aide aux utilisateurs sur
      l’utilisation du site en mettant l’utilisateur directement en contact avec
      les gérants du site travaillant au sein de Article 1. Les informations
      collectées par les cookies Crisp seront transmises et hébergées par Crisp
      sur des serveurs situés en Europe conformément à leur politique de
      confidentialité. Pour une présentation de la politique de confidentialité
      de Crisp, visitez https://crisp.chat/fr/privacy/.
    </Text>

    <Text>
      Notre site Internet utilise des cookies Google Analytics et Google Ad
      Grants. Les informations collectées par les cookies Google Analytics et
      Google Ad Grants seront transmises et hébergées par Google sur des
      serveurs situés aux Etats-Unis d’Amérique conformément à leur politique de
      confidentialité. Pour une présentation de la politique de confidentialité
      de Google et savoir comment cela s’applique à Google Analytics et Google
      Ad Grants, visitez http://www.google.com/intl/fr/policies/.
    </Text>

    <Text>
      Notre site Internet utilise des cookies Facebook. Les informations
      collectées par les cookies Facebook seront transmises et hébergées par
      Facebook sur des serveurs situés aux Etats-Unis d’Amérique conformément à
      leur politique de confidentialité. Pour une présentation de la politique
      de confidentialité de Facebook et savoir comment cela s’applique à
      Facebook, visitez https://fr-fr.facebook.com/policy.php
    </Text>

    <Text>
      Notre site Internet utilise des cookies Instagram. Les informations
      collectées par les cookies Instagram seront transmises et hébergées par
      Instagram sur des serveurs situés aux Etats-Unis d’Amérique conformément à
      leur politique de confidentialité. Pour une présentation de la politique
      de confidentialité de Instagram et savoir comment cela s’applique à
      Instagram, visitez
      https://fr-fr.facebook.com/help/instagram/519522125107875
    </Text>

    <Text>
      Notre site Internet utilise des cookies Snapchat. Les informations
      collectées par les cookies Snapchat seront transmises et hébergées par
      Snapchat sur des serveurs situés aux Etats-Unis d’Amérique conformément à
      leur politique de confidentialité. Pour une présentation de la politique
      de confidentialité de Snapchat et savoir comment cela s’applique à
      Snapchat, visitez https://www.snap.com/fr-FR/privacy/privacy-policy
    </Text>

    <Text>
      Notre site Internet utilise des cookies TikTok. Les informations
      collectées par les cookies TikTok seront transmises et hébergées parTikTok
      sur des serveurs situés aux Etats-Unis d’Amérique conformément à leur
      politique de confidentialité. Pour une présentation de la politique de
      confidentialité de TikTok et savoir comment cela s’applique à TikTok,
      visitez https://www.tiktok.com/legal/tiktok-website-cookies-policy?lang=fr
    </Text>

    <Text>
      Notre site Internet utilise des cookies Twitter. Les informations
      collectées par les cookies Twitter seront transmises et hébergées par
      Twitter sur des serveurs situés aux Etats-Unis d’Amérique conformément à
      leur politique de confidentialité. Pour une présentation de la politique
      de confidentialité de Facebook et savoir comment cela s’applique à
      Twitter, visitez https://twitter.com/fr/privacy
    </Text>

    <Text>
      Notre site Internet utilise des cookies Twilio, notre outil permettant
      l’envoi de SMS automatiques. Les informations collectées par les cookies
      Twilio seront transmises et hébergées par Twilio sur des serveurs situés
      aux Etats-Unis d’Amérique conformément à leur politique de
      confidentialité. Pour une présentation de la politique de confidentialité
      de Twilio et savoir comment cela s’applique à Twilio, visitez
      https://www.twilio.com/legal/privacy
    </Text>

    <Text>
      Vous pouvez désactiver les cookies en modifiant les paramètres de votre
      navigateur vous permettant ainsi de refuser l’installation de tout ou
      partie des cookies. Cependant, si vous désactivez tous les cookies par le
      biais des paramètres de votre navigateur (notamment les cookies
      strictement nécessaires au fonctionnement), il est probable que vous ne
      puissiez plus avoir accès à tout ou partie des sites. Désactiver un cookie
      ou une catégorie de cookies ne les supprime pas de votre navigateur, la
      suppression nécessitant une action spécifique.
    </Text>

    <Text>
      Si vous souhaitez modifier les paramètres des cookies, veuillez aller dans
      les menus « Options » ou « Préférences » de votre navigateur. Pour plus
      d’informations, rendez-vous dans l’option « Aide » de votre navigateur.
    </Text>

    <UnorderedList>
      <ListItem>
        Pour Chrome :
        https://support.google.com/chrome/answer/95647?hl=fr&hlrm=en
      </ListItem>
      <ListItem>
        Pour Internet Explorer :
        http://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-Cookies
      </ListItem>
      <ListItem>
        Pour FireFox :
        http://support.mozilla.org/fr/kb/cookies-informations-sitesenregistrent?redirectlocale=fr&redirectslug=G%C3%A9rer+les+cookies
      </ListItem>
      <ListItem>Pour Safari : http://support.apple.com/kb/PH11952</ListItem>
      <ListItem>
        Pour Opera : http://help.opera.com/Windows/12.10/fr/notrack.html
      </ListItem>
      <ListItem>
        Pour Edge :
        https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy
      </ListItem>
    </UnorderedList>

    <Text>
      Vous pouvez également vous désengager du suivi de Google Analytics en
      visitant https://tools.google.com/dlpage/gaoptout?hl=fr
    </Text>

    <Text>
      Si vous avez désactivé un ou plusieurs cookies d’analyse, sachez que nous
      pouvons toujours utiliser les informations collectées par les cookies
      installés antérieurement à la désactivation, cependant nous arrêterons
      d’utiliser les cookies désactivés pour collecter d’autres informations.
    </Text>
  </>
);

export default PrivacyPolicyContent;
